import { DatePipe } from '@angular/common';
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { FormControl, NgForm, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { AdjudicationBroadcastNameModel, AdjudicationBroadcastProxyFormModel, SupportingDocument } from '../adjudication-proxyform-screen/adjudicationbroadcastproxyform.model';
import { DataService } from 'src/app/core/data.service';
import { FloatMessageService } from 'src/app/shared/services/float-message.service';
import { UploadService } from 'src/app/shared/services/upload.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as moment from 'moment';

@Component({
  selector: 'app-adjudication-proxyform-popup',
  templateUrl: './adjudication-proxyform-popup.component.html',
  styleUrls: ['./adjudication-proxyform-popup.component.scss']
})
export class AdjudicationProxyFormPopupComponent {
 formData: any = {
    broadcastId:'',
    broadcastName: '',
    documentType: '',
    isSuperseding: 'false',
    remarks: '',
    submittedFileName:'',
    submittedFilePath:''
  };
 
  remarks:string="";
 
  isSubmitted:boolean=false;
  submissionForm: UntypedFormGroup;
  selectedFile: File | null = null;

  reasonPattern=new RegExp("^[a-zA-Z0-9 `~@#%&*()\\-_+;:,\\\"'/\\\\. !@#$%^&*()_+{}|:\"<>?/.,';\\[\\]=\r\n]*$");


  isAdjudicationSummaryExist: boolean = false;
  submittedFileName:string;
  submittedFilePath:string;
  isSupportingDocumentFileSubmitted:boolean =false;

  errorMessage='Please submit with supporting documents in order to process this claim.';

  emitFiles: any[] = [];
  buttonName: string;
  itemNumber = 1;
  totalAmount: any = null;
  dateTime = new Date();
  totalDocument: number = null;
  currencyId: number = null;
  userId: any = null;
  showSaveAsDraft: boolean = false;
  saveAsDraftMode: boolean = false;
  engagementId: string;
  adjudicationId:string;
  creditorId:string;
  documentTypeId:any;
  viewOrEdit: boolean = false;
  isEdit: boolean = false;
  podResubmit: boolean;
  hideError: boolean = true;
  pipe = new DatePipe('en-US');
  isDateIncurredSubmit:boolean=false;
  @ViewChild('dateOfIncurred') selectedDate: ElementRef;
  deletedFiles: any[] = [];
  cloneDeletedFiles: any[] = [];
  isUpdate: boolean = true;
  isFileSubmit: boolean;
  public folderPathId: any = null;
  adjudicationBroadcastProxyFormModel:AdjudicationBroadcastProxyFormModel = new AdjudicationBroadcastProxyFormModel();
  disableControls: boolean = false;
  file: SupportingDocument =new  SupportingDocument();
  constructor( public dialogRef: MatDialogRef<AdjudicationProxyFormPopupComponent>,private formBuilder: UntypedFormBuilder,
  @Inject(MAT_DIALOG_DATA) public data: AdjudicationBroadcastNameModel,private dataService: DataService,private floatMessage: FloatMessageService,private uploadService: UploadService,private spinnerService: NgxSpinnerService) { 
    
  }

  ngOnInit(): void {
    this.viewOrEdit = this.data.details.viewOrEdit ?? false;
    this.isEdit = this.data.details.isEdit ?? false;
    this.disableControls = this.viewOrEdit && !this.isEdit;
    this.submissionForm = this.formBuilder.group({
      broadcastId: ['', [Validators.required]],
      broadcastName: [''],
      documentType: ['', [Validators.required]],
      isSuperseding: 'false',
      remarks: '',
      submittedFileName: '',
      submittedFilePath: '',
      supersededProxyFormId:null
    });
    this.submissionForm.controls?.isSuperseding.disable();
    if (!this.viewOrEdit) {
      this.resetForm();
      this.adjudicationBroadcastProxyFormModel.proxyFormId='00000000-0000-0000-0000-000000000000'
    }
    else{
      let data={
        proxyFormId:this.data.details.proxyFormId
      }
      this.spinnerService.show();
      let path = 'CreditorClaim/GetAdjudicationProxyFormDetailsByIdQuery';
      this.dataService.postRequest(path,data).subscribe((x:any) => {
        this.data.details.engagementId =x.engagementId;
        this.formData.broadcastId=x.broadcastId;
        this.data.broadcastNamePublishDate.find(x => x.id === this.formData.broadcastId)?.broadcastNamePublishDate;
        this.data.details.creditorId=x.creditorId;
        this.formData.documentType=x.documentTypeId;
        this.data.details.particularsOfDebtId=x.particularsOfDebtId;
        this.adjudicationBroadcastProxyFormModel.proxyFormId=x.id;
        this.formData.submittedFilePath = x.filePath;
        this.formData.submittedFileName = x.originalFileName;
        this.adjudicationBroadcastProxyFormModel.originalFileName = x.originalFileName;
        this.adjudicationBroadcastProxyFormModel.filePath = x.filePath;
        this.adjudicationBroadcastProxyFormModel.fileSize = x.fileSize;
        this.file.name=x.originalFileName;
        this.file.webkitRelativePath='';
        this.file.lastModifiedDate = x.uploadedDatetime;
        this.file.convertedDate = "" + moment(x.uploadedDatetime).format("DD-MMM-yyyy, h:mm A");
        this.file.filePath=x.filePath;
        this.file.date = moment(x.uploadedDatetime).local();
        this.file.fileSize=x.fileSize;
        this.file.size=x.fileSize;
        this.file.getDetails=this.file;
        this.submissionForm.controls['remarks'].setValue(x.remarks);
        this.submissionForm.controls['supersededProxyFormId'].setValue(x.supersededProxyFormId);
        this.emitFiles.push(this.file);
        if(x.supersededFilePath){
          this.formData.submittedFilePath = x.supersededFilePath;
          this.formData.submittedFileName = x.supersededOriginalFileName;
          this.isAdjudicationSummaryExist = true;
          this.formData.isSuperseding = 'true';
        }
        if(this.viewOrEdit){
          this.submissionForm.controls?.broadcastId.disable();
          this.submissionForm.controls?.documentType.disable();
          this.submissionForm.controls?.remarks.disable();
          this.file.showDelete=true;
          this.file.isUpdate=true;
          this.file.isView=true;
        }
        this.spinnerService.hide();
      });
    
    }
  }

  resetForm() {
    this.formData = {
      broadcastId: '',
      broadcastName: '',
      documentType: '',
      isSuperseding: 'false',
      remarks: '',
      submittedFileName: '',
      submittedFilePath: ''
    };
  }

  public onClickToSelectPrimary(primaryBtnName: string) {
    this.dialogRef.close({ data: primaryBtnName });
  }

  public onClickToSelectSecondary(secondaryBtnName: string) {
    this.dialogRef.close({ data: secondaryBtnName });
  }


  onSubmit() {
    this.isFileSubmit=true;
    this.emitFiles.forEach(async (file: any) => {
      this.adjudicationBroadcastProxyFormModel.originalFileName = file.name;
      this.adjudicationBroadcastProxyFormModel.createdBy = this.userId;
      this.adjudicationBroadcastProxyFormModel.filePath = file.filePath;
      this.adjudicationBroadcastProxyFormModel.fileSize = file.fileSize;
      this.adjudicationBroadcastProxyFormModel.uploadedDatetime = new Date(file.date).toISOString();
    });
    if (this.submissionForm.valid) {
      let path = 'CreditorClaim/createAdjudicationProxyForm';
      this.isFileSubmit=false;
      this.adjudicationBroadcastProxyFormModel.engagementId = this.data.details.engagementId;
      this.adjudicationBroadcastProxyFormModel.broadcastId = this.submissionForm.value.broadcastId;
      this.adjudicationBroadcastProxyFormModel.broadcastNameWithDate = this.data.broadcastNamePublishDate.find(x => x.id === this.submissionForm.value.broadcastId)?.broadcastNamePublishDate;
      this.adjudicationBroadcastProxyFormModel.creditorId = this.data.details.creditorId;
      this.adjudicationBroadcastProxyFormModel.documentTypeId = this.submissionForm.value.documentType;
      this.adjudicationBroadcastProxyFormModel.isSuperseded = this.formData.isSuperseding =="true" ? true : false;
      this.adjudicationBroadcastProxyFormModel.particularsOfDebtId = this.data.details.particularsOfDebtId;
      this.adjudicationBroadcastProxyFormModel.publishedDate = this.data.broadcastNamePublishDate.find(x => x.id === this.submissionForm.value.broadcastId)?.publishDateTime;
      this.adjudicationBroadcastProxyFormModel.createdBy = sessionStorage.getItem('userId');
      this.adjudicationBroadcastProxyFormModel.remarks = this.submissionForm.value.remarks;
      this.adjudicationBroadcastProxyFormModel.supersededProxyFormId=this.formData.supersededProxyFormId ? this.formData.supersededProxyFormId : (this.submissionForm.value.supersededProxyFormId ? this.submissionForm.value.supersededProxyFormId : null) ;
      if(this.emitFiles.length==0){
        this.isSupportingDocumentFileSubmitted=true;
        this.adjudicationBroadcastProxyFormModel.originalFileName = null;
        this.adjudicationBroadcastProxyFormModel.filePath = null;
        this.adjudicationBroadcastProxyFormModel.fileSize = null;
        this.adjudicationBroadcastProxyFormModel.uploadedDatetime = null;
        return;
      }
      else{
        this.isSupportingDocumentFileSubmitted=false;
      }
      // this.adjudicationBroadcastProxyFormModel.engagementId = this.data.details.engagementId;
      // this.adjudicationBroadcastProxyFormModel.broadcastId = this.formData.broadcastId;
      // this.adjudicationBroadcastProxyFormModel.broadcastNameWithDate = this.data.broadcastNamePublishDate.find(x => x.id === this.formData.broadcastId)?.broadcastNamePublishDate;
      // this.adjudicationBroadcastProxyFormModel.creditorId = this.data.details.creditorId;
      // this.adjudicationBroadcastProxyFormModel.documentTypeId = this.formData.documentType;
      // this.adjudicationBroadcastProxyFormModel.isSuperseded = this.formData.isSuperseding =="true" ? true : false;
      // this.adjudicationBroadcastProxyFormModel.particularsOfDebtId = this.data.details.particularsOfDebtId;
      // this.adjudicationBroadcastProxyFormModel.publishedDate = this.data.broadcastNamePublishDate.find(x => x.id === this.formData.broadcastId)?.publishDateTime;
      // this.adjudicationBroadcastProxyFormModel.createdBy = sessionStorage.getItem('userId');
      // this.adjudicationBroadcastProxyFormModel.remarks = this.formData.remarks;
      // this.adjudicationBroadcastProxyFormModel.supersedProxyFormId=this.formData.supersedProxyFormId;
      this.dataService.postRequest(path, this.adjudicationBroadcastProxyFormModel).subscribe(x => {
        this.floatMessage.showNotification("success", "Proxy Form has been submitted successfully.");
        this.dialogRef.close({ data: "APPLY" });
      });
    } else {
      console.warn('Form is invalid');
    }
  }
  onCancel() { 
    this.submissionForm.reset(); 
  } 

  get getFormControls() {
    return this.submissionForm.controls;
  }
  getFiles(event: any): void {
    this.emitFiles = event;
    this.totalDocument = event.length;
    if(this.emitFiles.length!=0){
      this.isSupportingDocumentFileSubmitted=false;
    }
    // to prevent navigation if a file is added
    UtilitiesService.SetIsEditScreenActiveToTrue();
  }
  
  hideMessage() {
    this.isFileSubmit = false;
    this.hideError = true;
  }
    getDeletedFiles(files: any) {
    this.cloneDeletedFiles.push(files);
    // to prevent navigation if a file is deleted
    UtilitiesService.SetIsEditScreenActiveToTrue();
  }
  onClickToChangeBroadcastName(id:any){
    this.data.broadcastDocumentTypeLookup = [];
    let path = 'broadcasts/getdocumenttypebybroadcastid';
    var data:any = {
      id: id
    };
    this.dataService.getRequestwithObject(path,data).subscribe((result:any)=> {
      this.data.broadcastDocumentTypeLookup = result;
      this.submissionForm.get('documentType')?.setValue('');
      this.isFileSubmit = false;
    })
    if(this.formData.documentType){
      let path = 'CreditorClaim/CheckAdjudicationSummaryExists';
      let data: any={
        broadcastId:id,
        creditorId:this.data.details.creditorId,
        documentTypeId:this.formData.documentType,
        proxyFormId:this.data.details.proxyFormId ? this.data.details.proxyFormId:null
      }
      this.spinnerService.show();
      this.dataService.postRequest(path, data).subscribe((x:any) => {
        if(x){
          this.formData.submittedFilePath = x.submittedFilePath;
          this.formData.submittedFileName = x.submittedFileName;
          this.formData.isSuperseding = 'true';
          this.formData.supersededProxyFormId=x.supersededProxyFormId;
        } else {
          // this.formData.submittedFilePath = '';
          // this.formData.submittedFileName = '';
          this.formData.isSuperseding = 'false';
          this.formData.supersededProxyFormId=null;
        }
        this.spinnerService.hide();
          
      });
    }
  }
  onClickToChangeDocumentType(id:any){
    if(this.formData.broadcastId){
      let path = 'CreditorClaim/CheckAdjudicationSummaryExists';
      let data: any={
        broadcastId:this.formData.broadcastId,
        creditorId:this.data.details.creditorId,
        documentTypeId:id,
        proxyFormId:this.data.details.proxyFormId ? this.data.details.proxyFormId:null
      }
      this.spinnerService.show();
      this.dataService.postRequest(path, data).subscribe((x:any) => {
        if(x){
          this.formData.submittedFilePath = x.submittedFilePath;
          this.formData.submittedFileName = x.submittedFileName;
          this.formData.isSuperseding = 'true';
          this.formData.supersededProxyFormId=x.supersededProxyFormId;
        } else {
          // this.formData.submittedFilePath = '';
          // this.formData.submittedFileName = '';
          this.formData.isSuperseding = 'false';
          this.formData.supersededProxyFormId=null;
        }
        this.spinnerService.hide();
          
      });
    }
  }
  downloadFile(file:any){
    this.uploadService.downloadFile(file.submittedFilePath, file.submittedFileName)
  } 

  public addressLineFormat(event){
    var regex = new RegExp(this.reasonPattern);
    var key = event.key;
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  }
}


